const state = {
  currentModule: 'energyFlow',
  sidebarCollapsed: false
}

const mutations = {
  SET_CURRENT_MODULE(state, module) {
    state.currentModule = module
  },
  TOGGLE_SIDEBAR(state) {
    state.sidebarCollapsed = !state.sidebarCollapsed
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
